export const LANG = {
    UA: 'ua',
    RU: 'ru',
    UK: 'uk'
};
